export default __webpack_public_path__ + "static/media/904.0311fb55.jpg";